export const ADMIN_HEADER_INFORMATION = 'infos';
export const ADMIN_HEADER_PAYMENTS = 'payments';
export const ADMIN_HEADER_PARTICIPANTS = 'peoples';
export const ADMIN_HEADER_SENDING_GROUP = 'group-send';
